module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-237.fdd3781a.svg";